import type { ProductCopyRequest, ProductCopyResponse } from './apiAdminProduct'
import { useApi } from '@shared/api'
import type { Addon, CreateAddonDto, UpdateAddonDto } from '@entities/product'

export const apiAdminAddons = {
  async getAll(): Promise<Addon[]> {
    const { data } = await useApi(true, true).get<Addon[]>('/addons')
    return data
  },

  async getById(id: number): Promise<Addon> {
    const { data } = await useApi(true, true).get<Addon>(`/addons/${id}`)
    return data
  },

  async create(payload: CreateAddonDto): Promise<Addon> {
    const { data } = await useApi(true, true).post<Addon>('/addons', { body: payload })
    return data
  },

  async updateFull(id: number, payload: CreateAddonDto): Promise<Addon> {
    const { data } = await useApi(true, true).put<Addon>(`/addons/${id}`, { body: payload })
    return data
  },

  async update(id: number, payload: UpdateAddonDto | FormData): Promise<Addon> {
    const { data } = await useApi(true, true).patch<Addon>(`/addons/${id}`, { body: payload })
    return data
  },

  /**
   * Копия добавки в другой филиал: переносит название, описание, цену и картинки.
   * Модификаторов у добавки нет, поэтому отчёт сопоставления в ответе всегда пустой.
   */
  async copy(id: number, payload: ProductCopyRequest): Promise<ProductCopyResponse> {
    const { data } = await useApi(true, true).post<ProductCopyResponse>(`/addons/${id}/copy`, { body: payload })
    return data
  },

  async delete(id: number): Promise<{ message: string }> {
    const { data } = await useApi(true, true).delete<{ message: string }>(`/addons/${id}`)
    return data
  },

  async deleteImage(id: number, imageKey: string): Promise<{ message: string; remainingImages: number }> {
    const { data } = await useApi(true, true).delete<{ message: string; remainingImages: number }>(
      `/addons/${id}/img/${encodeURIComponent(imageKey)}`,
    )
    return data
  },
}

export default apiAdminAddons
